import { useMediaQuery } from 'react-responsive';
import { ScreenBreakpoint } from 'src/styles';

export const useIsMobile = () => {
  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  return isMobile;
};
